import {YouTubeVideoModel} from "../../../models/domain/youTubeVideoModel";
import {Button} from "react-bootstrap";
import {FaYoutube} from "react-icons/fa";
import React from "react";

export const YouTubePlayButton = ({model: {thumbnailCollection: {poster: {url}}, title}, onClick}: { model: YouTubeVideoModel, onClick: () => void; }) => (
    <>
        <img
            src={url}
            alt={title}
            aria-hidden
            className="d-block poster-image img-fluid"
            height={360}
            width={640}
        />
        <Button
            tabIndex={0}
            variant="link"
            title={`Play Youtube Video: ${title}`}
            onClick={onClick}
            aria-label="Play Youtube Video"
            className="position-absolute top-50 start-50 translate-middle">
            <FaYoutube size={150} className="text-danger" style={{maxWidth: "25vw"}}/>
            <div className="bg-white position-absolute top-50 start-50 translate-middle"
                 style={{height: "25%", width: "25%", zIndex: "-1"}}/>
        </Button>
    </>
);